<template>
  <div class="action-card bg-white action-card-primitive rounded-2 position-relative mb-n6 mx-auto mx-lg-0">
    <div class="p-2 action-card-header bg-white" style="border-radius: 6px">

      <EditableIcon v-model="item.icon" :is-editable="isEditable" />
      <ellipsis-button
        v-if="isEditable"
        style="float: right"
        placement="bottom"
        :heading="null"
        :show-options="['slot', 'duplicate', 'delete']"
        @duplicate="onDuplicate"
        @delete="onRemove">

        <el-button
          @click="onAddDescription"
          size="mini"
          class="ml-0 btn-block mt-4"
          :disabled="!!item.description">
          Add description
        </el-button>

      </ellipsis-button>

      <h4 class="m-0">
        <inline-editable-text
          @change="onUpdate({ title: $event })"
          :value="item.title"
          :inline="true"
          :reset-on-update="false"
          :reset-on-cancel="false"
          :lost-focus-is-update="false"
          :is-editable="isEditable"
          />
      </h4>

      <div class="d-flex justify-content-between">
        <div class="text-gray m-0 text-truncate">
          <strong>{{action.type}}</strong>
        </div>
        <div class="text-black">
          <template v-if="action.type === 'SESSION:TASK'">
            <TaskSelector v-model="action_task" />
          </template>
          <template v-if="action.type === 'SESSION' || action.type === 'PAUSE'">
            <duration-quick-settings v-model="action.sessionLength" @save="onQuickSetDurationTask" v-if="isEditable"/>
            <span v-else>{{action.sessionLength | hoursMinutes}}</span>
          </template>
          <template v-if="action.type === 'NEXT:DAY'">
            <repeat-quick-settings v-model="action.repeat" @save="onQuickSetRepeat" v-if="isEditable"/>
            <span v-else>{{action.repeat}}</span>
            {{ $tc('day', action.repeat) }}
          </template>
          <template v-if="action.type === 'NEXT:WEEK'">
            <repeat-quick-settings v-model="action.repeat" @save="onQuickSetRepeat" v-if="isEditable"/>
            <span v-else>{{action.repeat}}</span>
            {{ $tc('week', action.repeat) }}
          </template>
          <template v-if="action.type === 'NEXT:WEEKDAY'">
            <weekday-quick-settings v-model="action.weekday" @save="onQuickSetWeekday" v-if="isEditable"/>
            <span v-else>{{action.weekday}}</span>
          </template>
          <template v-if="action.type === 'NEXT:DATE'">
            <date-selector-inline v-model="action.date" v-if="isEditable" />
            <span v-else>{{action.date ? 'until ' + $options.filters.longDate(action.date) : 'no date'}}</span>
          </template>
        </div>
      </div>
    </div>
    <div class="action-card-details px-3 py-2" v-if="item.description">
      <span class="caption">Description:</span>
      <!--
      <EditableMultilineText @update="onUpdate({ description: $event })" :text="item.description" :inline="true" >
        <p slot-scope="props">{{props.text}}</p>
      </EditableMultilineText>
      -->
      <markdown-text
        @input="onUpdate({ description: $event })"
        :value="item.description"
        :show-as-markdown="true"
        :enable-inline-editing="true"
        :is-editable="isEditable" />

      <a v-if="isEditable" href="#" @click.prevent="onRemoveDescription">remove description</a>

      <!-- <pre class="mini-pre">{{item}}</pre> -->
      <slot></slot>
    </div>
    <div class="action-card-controls text-right">
    </div>
    <div v-if="showConnection" class="workflow-string position-absolute"></div>
  </div>
</template>

<script>
import Vue from 'vue';
import EditableIcon from './EditableIcon'
import DurationQuickSettings from '@/components/Elements/DurationQuickSettings'
import TaskSelector from './TaskSelector'
import clonedeep from 'lodash.clonedeep'

// TODO: Tab through editable items

export default {
  name: "WorkflowPrimitive",
  props: {
    value: {},
    showConnection: {
      default: true
    },
    isEditable: {
      default: true
    }
  },
  created() {
  },
  data: () => ({
    item: {}
  }),
  watch: {
    value: {
      handler( newValue ) {
        this.item = newValue;
      },
      deep: true,
      immediate: true
    },
  },
  computed: {
    action() {
      return this.item.actions[0];
    },
    action_task: {
      get() {
        return {
          taskId:   this.action.taskId,
          memberId: this.action.memberId,
          goalId:   this.action.goalId,
        }
      },
      set( value ) {
        this.action.taskId   = value.taskId;
        this.action.memberId = value.memberId;
        this.action.goalId   = value.goalId;
      }
    }
  },
  methods: {
    onRemove() {
      this.$emit('remove');
    },
    onDuplicate() {
      let item_clone = clonedeep( this.item )
      this.$emit('duplicate', item_clone)
    },
    onUpdate(data) {
      console.log("onUpdate", data)
      for ( var prop in data ) {
        Vue.set(this.item, prop, data[ prop ]);
      }
      this.$emit('input', this.item)
    },
    onQuickSetRepeat(x) {
      console.log("onQuickSetRepeat", x);
      this.item.actions[0].repeat = x;
      this.$emit('input', this.item)
    },
    onQuickSetWeekday(x) {
      console.log("onQuickSetWeekday", x);
      this.item.actions[0].weekday = x;
      this.$emit('input', this.item)
    },
    onQuickSetDurationTask(x) {
      console.log("onQuickSetDurationTask", x);
      this.item.actions[0].sessionLength = x;
      this.$emit('input', this.item)
    },
    onAddDescription() {
      console.log("onAddDescription", this.item)
      Vue.set(this.item, 'description', 'Description...');
      // this.item.description = 'Description...';
      this.$emit('input', this.item)
    },
    onRemoveDescription() {
      console.log("onRemoveDescription", this.item)
      Vue.set(this.item, 'description', null);
      // this.item.description = null;
      this.$emit('input', this.item)
    }
  },
  components: {
    EditableIcon,
    DurationQuickSettings,
    TaskSelector,
  }
}
</script>

<style>
.action-card-primitive {
  border: 1px solid #606266;
}
.action-card-primitive::before {
  box-shadow: 0 0 0 1px #606266 !important;
}
.action-card-primitive::after {
  box-shadow: 0 0 0 1px #606266 !important;
}
.action-card-primitive .action-card-details .caption {
  color: #999;
  font-variant: small-caps;
}
</style>
